import { render } from "./block_texto.vue?vue&type=template&id=333155c8"
import script from "./block_texto.vue?vue&type=script&lang=js"
export * from "./block_texto.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__